export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/Block4_Mobile-703b25d169b2ce5a343050d77c1a0cda.png";